import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

const Error = ({ message, header, style }) => (
  <Alert bsStyle="danger" style={{ width: '60%', margin: 'auto', marginTop: 25, ...style }}>
    <h4>{header || 'An Error has occurred'}</h4>
    <p>{message}</p>
  </Alert>
);

Error.propTypes = {
  message: PropTypes.string.isRequired,
  header: PropTypes.string,
  style: PropTypes.object,
};

Error.defaultProps = {
  style: {},
  header: null,
};

export default Error;



// WEBPACK FOOTER //
// ./src/components/Error.js